module.exports = __webpack_public_path__ + "img/dnd_5_splash.5507f348.jpg";